export default __webpack_public_path__ + "static/media/techBlog-sq.945d93a5.jpg";